<template>
    <div class="text-center mt-4 pt-4" >
        <button class="btn btn-info" @click="$store.commit('showModal', 'newProduct')"><i class="fas fa-plus"></i> Nouveau produit</button>
    </div>
</template>
<script>
    export default {

    }
</script>